// Shared toolbar primitives for the floating HUD panels (org chart header,
// directory search bar). Keep these presentational — no data fetching, no
// app-specific logic.

export function InlineStatBadge({ label, value, isDark: _isDark, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-baseline gap-1 rounded-ctl px-2 py-1 transition-colors
                  ${onClick ? 'cursor-pointer hover:bg-surface-2' : 'cursor-default'}`}
    >
      <span className="text-sm font-semibold text-ink">{value}</span>
      <span className="text-[10px] font-medium text-ink-3">{label}</span>
    </button>
  );
}

// isDark is accepted but unused — kept so existing call sites need no edit while
// components migrate onto tokens. Remove the prop once nothing passes it.
export function HudIconButton({ onClick, title, active = false, isDark: _isDark, pill = false, children }) {
  return (
    <button
      onClick={onClick}
      title={title}
      className={`relative w-[38px] h-[38px] ${pill ? 'rounded-full' : 'rounded-ctl'} flex items-center justify-center flex-shrink-0
                  border transition-colors shadow-e1
                  ${active
                    ? 'bg-accent border-accent text-[var(--on-accent)]'
                    : 'bg-surface border-line text-ink-2 hover:text-accent hover:border-line-strong'}`}
    >
      {children}
    </button>
  );
}

export function ToolbarButton({ children, onClick, isDark: _isDark, active = false, disabled = false, compact = false }) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${compact ? 'h-8 text-[10.5px] flex-shrink-0' : 'h-10 text-[11px]'}
                  rounded-full px-3 font-semibold transition-colors whitespace-nowrap border
                  disabled:opacity-40 disabled:cursor-default
                  ${active
                    ? 'bg-accent border-accent text-[var(--on-accent)]'
                    : 'bg-surface border-line text-ink hover:border-line-strong'}`}
    >
      {children}
    </button>
  );
}
